export default __webpack_public_path__ + "static/media/slides.a570368a.svg";